import getCreditScoreDetails from "./get-credit-score-details";

export default getCreditScoreDetails;